import React, { useState, useEffect, useRef, forwardRef } from "react";
import { FloatingLabel, Form, FormControl } from "react-bootstrap";
import ReactSelect from "react-select/creatable";
import { components } from "react-select";
import ReactDOM from "react-dom";

import Button from "./Button";

const Overlay = (props) => {
  return <div className="overlay-modal-box" onClick={props.closeoverlay}></div>;
};

const OverlayModal = (props) => {
  const { rename } = props;

  return (
    <div className="adding-content rename-modal">
      <Form onSubmit={props.renameSubmit} autoComplete="off">
        <div class="inputbox-group">
          <label class="col-12">Attribute Name</label>
          <input
            type="text"
            placeholder="Attribute Name"
            name="headerName"
            value={rename.headerName}
            onChange={props.attrRenaming}
            className="form-control"
          />
          <div className="error">{props.error}</div>
        </div>
        <div class="inputbox-group mt-2">
          <label class="col-12">Attribute Type</label>
          <select
            disabled
            value={rename.attribute_type}
            className="form-control"
          >
            {" "}
            <option>Select Type</option>
            <option value="text">Text</option>
            <option value="textarea">Textarea</option>
            <option value="priority">Priority</option>
            <option value="select">Select</option>
            <option value="effort">Effort</option>
            <option value="product">Product</option>
            <option value="radio">Radio</option>
            <option value="toggle">Toggle</option>
            <option value="checkbox">Checkbox</option>
            <option value="status">status</option>
            <option value="category">category</option>
            <option value="monitoring">Monitoring</option>
            <option value="priority">Priority</option>
            <option value="reporter">Reporter</option>
            <option value="people">People</option>
            <option value="assign_to">Assign To</option>
            <option value="email">Email</option>
            <option value="effort">Effort</option>
            <option value="timestamp">Timestamp</option>
            <option value="attachment">Attachment</option>
            <option value="er">ER</option>
            <option value="url">URL</option>
            <option value="customer">Customer</option>
            <option value="name">Customer Name</option>
            <option value="company_name">Company Name</option>
            <option value="date">Date</option>
            <option value="start_date">Start Date</option>
            <option value="end_date">End Date</option>
            <option value="go_live_date">Go Live Date</option>
            <option value="multi-select">Multi Select</option>
            <option value="tel">Tel</option>
            <option value="people">People</option>
            <option value="tag">Tag</option>
            <option value="age">Age</option>
            <option value="cc">CC</option>
            <option value="er">ER</option>
            <option value="api">Api</option>
            <option value="number">Number</option>
            <option value="board">Board</option>
            <option value="account_manager">Account Manager</option>
            <option value="cc">CC</option>
            <option value="customer_type">Customer Type</option>
          </select>
          <div className="error">{props.error}</div>
        </div>
        {["select", "radio", "checkbox", "priority", "multi-select"].includes(
          rename.attr_type
        ) && (
          <ReactSelect
            ref={props.cleareactSelect}
            options={props.attrnewopt}
            className="mt-3 abc"
            menuIsOpen={true}
            styles={props.colourStyles}
            components={{ Option: props.IconOption }}
            clearValue={true}
            onChange={props.createCustomOptionHandler}
          />
        )}
        {rename.attribute_type === "api" && (
          <div class="inputbox-group mt-2">
            <label class="col-12">{rename.headerName}</label>
            <input
              type="text"
              className="form-control"
              value={rename.api_url}
              name="api_url"
              onChange={props.onChange}
              disabled="disabled"
            />
          </div>
        )}
        {rename.attr_type === "date" && (
          <div className="d-flex align-items-center mt-3">
            <input
              type="checkbox"
              className="form-check-input"
              checked={rename.set_current_date}
              name={rename.field}
              disabled
            />
            &nbsp;
            <span>set date as current date</span>
          </div>
        )}
        &nbsp;
        <span
          class="float-start mt-4 advance-se "
          onClick={props.showFormCanvas}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z"
              stroke="#7B8794"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M11.3163 8.75016C11.2387 8.92611 11.2155 9.12128 11.2498 9.31051C11.2841 9.49974 11.3744 9.67435 11.5088 9.81183L11.5438 9.84683C11.6523 9.95518 11.7384 10.0839 11.7971 10.2255C11.8558 10.3671 11.886 10.5189 11.886 10.6722C11.886 10.8256 11.8558 10.9774 11.7971 11.119C11.7384 11.2606 11.6523 11.3893 11.5438 11.4977C11.4355 11.6061 11.3068 11.6922 11.1652 11.7509C11.0236 11.8096 10.8717 11.8398 10.7184 11.8398C10.5651 11.8398 10.4133 11.8096 10.2717 11.7509C10.13 11.6922 10.0014 11.6061 9.89301 11.4977L9.85801 11.4627C9.72053 11.3282 9.54591 11.238 9.35668 11.2037C9.16745 11.1693 8.97228 11.1925 8.79634 11.2702C8.62381 11.3441 8.47666 11.4669 8.37302 11.6234C8.26938 11.7799 8.21376 11.9633 8.21301 12.151V12.2502C8.21301 12.5596 8.09009 12.8563 7.8713 13.0751C7.65251 13.2939 7.35576 13.4168 7.04634 13.4168C6.73692 13.4168 6.44018 13.2939 6.22138 13.0751C6.00259 12.8563 5.87967 12.5596 5.87967 12.2502V12.1977C5.87516 12.0046 5.81266 11.8173 5.70031 11.6602C5.58795 11.5031 5.43094 11.3835 5.24967 11.3168C5.07373 11.2392 4.87856 11.216 4.68933 11.2503C4.5001 11.2846 4.32549 11.3748 4.18801 11.5093L4.15301 11.5443C4.04466 11.6528 3.91599 11.7389 3.77435 11.7976C3.63272 11.8563 3.48091 11.8865 3.32759 11.8865C3.17427 11.8865 3.02246 11.8563 2.88083 11.7976C2.7392 11.7389 2.61053 11.6528 2.50217 11.5443C2.3937 11.436 2.30765 11.3073 2.24894 11.1657C2.19023 11.024 2.16001 10.8722 2.16001 10.7189C2.16001 10.5656 2.19023 10.4138 2.24894 10.2721C2.30765 10.1305 2.3937 10.0018 2.50217 9.8935L2.53717 9.8585C2.67165 9.72102 2.76187 9.5464 2.79618 9.35717C2.83049 9.16794 2.80732 8.97277 2.72967 8.79683C2.65573 8.6243 2.53295 8.47715 2.37645 8.37351C2.21994 8.26986 2.03655 8.21424 1.84884 8.2135H1.74967C1.44026 8.2135 1.14351 8.09058 0.924717 7.87179C0.705924 7.65299 0.583008 7.35625 0.583008 7.04683C0.583008 6.73741 0.705924 6.44066 0.924717 6.22187C1.14351 6.00308 1.44026 5.88016 1.74967 5.88016H1.80217C1.99525 5.87565 2.18251 5.81315 2.3396 5.70079C2.49669 5.58844 2.61634 5.43142 2.68301 5.25016C2.76066 5.07422 2.78382 4.87905 2.74951 4.68982C2.7152 4.50059 2.62499 4.32598 2.49051 4.1885L2.45551 4.1535C2.34704 4.04514 2.26098 3.91647 2.20227 3.77484C2.14356 3.63321 2.11334 3.4814 2.11334 3.32808C2.11334 3.17476 2.14356 3.02295 2.20227 2.88132C2.26098 2.73968 2.34704 2.61101 2.45551 2.50266C2.56386 2.39419 2.69253 2.30814 2.83416 2.24943C2.97579 2.19071 3.12761 2.16049 3.28092 2.16049C3.43424 2.16049 3.58606 2.19071 3.72769 2.24943C3.86932 2.30814 3.99799 2.39419 4.10634 2.50266L4.14134 2.53766C4.27882 2.67214 4.45343 2.76235 4.64266 2.79667C4.83189 2.83098 5.02707 2.80781 5.20301 2.73016H5.24967C5.42221 2.65622 5.56935 2.53344 5.673 2.37693C5.77664 2.22043 5.83226 2.03704 5.83301 1.84933V1.75016C5.83301 1.44074 5.95592 1.144 6.17472 0.925205C6.39351 0.706412 6.69026 0.583496 6.99967 0.583496C7.30909 0.583496 7.60584 0.706412 7.82463 0.925205C8.04342 1.144 8.16634 1.44074 8.16634 1.75016V1.80266C8.16709 1.99037 8.22271 2.17377 8.32635 2.33027C8.43 2.48677 8.57714 2.60955 8.74967 2.6835C8.92562 2.76115 9.12079 2.78431 9.31002 2.75C9.49925 2.71569 9.67386 2.62548 9.81134 2.491L9.84634 2.456C9.95469 2.34752 10.0834 2.26147 10.225 2.20276C10.3666 2.14405 10.5184 2.11383 10.6718 2.11383C10.8251 2.11383 10.9769 2.14405 11.1185 2.20276C11.2602 2.26147 11.3888 2.34752 11.4972 2.456C11.6056 2.56435 11.6917 2.69302 11.7504 2.83465C11.8091 2.97628 11.8393 3.12809 11.8393 3.28141C11.8393 3.43473 11.8091 3.58655 11.7504 3.72818C11.6917 3.86981 11.6056 3.99848 11.4972 4.10683L11.4622 4.14183C11.3277 4.27931 11.2375 4.45392 11.2032 4.64315C11.1689 4.83238 11.192 5.02755 11.2697 5.2035V5.25016C11.3436 5.42269 11.4664 5.56984 11.6229 5.67348C11.7794 5.77713 11.9628 5.83275 12.1505 5.8335H12.2497C12.5591 5.8335 12.8558 5.95641 13.0746 6.1752C13.2934 6.394 13.4163 6.69074 13.4163 7.00016C13.4163 7.30958 13.2934 7.60633 13.0746 7.82512C12.8558 8.04391 12.5591 8.16683 12.2497 8.16683H12.1972C12.0095 8.16758 11.8261 8.2232 11.6696 8.32684C11.5131 8.43049 11.3903 8.57763 11.3163 8.75016V8.75016Z"
              stroke="#7B8794"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>{" "}
          &nbsp;<span class="pointer-class">Properties</span>
        </span>
        <Button
          type="submit"
          text="submit"
          className="muBtn _blue mt-3 btn-sm float-end"
        />{" "}
        <Button
          type="button"
          text="cancel"
          className="btn btn-danger ml-2 mt-3 btn-sm float-end cancel-modal-rename"
          onClick={props.cancelRename}
        />
      </Form>
    </div>
  );
};
const RenameAttrModal = (props) => {
  const cleareactSelect = useRef();
  const [rename, setRename] = useState({
    rename: false,
    headerName: "",
    field: "",
    options: [],
  });
  const [attrOptions, setAttrOptions] = useState(rename.options);
  const [error, setError] = useState("");
  useEffect(() => {
    const newDetailsprops = {
      ...props.rename,
      newoptionsextra: [],
    };
    setRename(newDetailsprops);
  }, [props.rename]);

  const attrRenaming = (ev) => {
    const renameing = { ...rename };
    renameing[ev.target.name] = ev.target.value;
    setRename(renameing);
  };
  const colourStyles = {
    control: (styles) => ({ ...styles, height: "56px" }),
  };

  const createCustomOptionHandler = (newValue, actionMeta) => {
    if (actionMeta.action == "create-option") {
      const newoptions = [...rename.options];
      newoptions.unshift(createOption(newValue.value));
      const extraoption = [...rename.newoptionsextra];
      extraoption.unshift(createOption(newValue.value));
      setRename((state) => {
        return { ...state, options: newoptions, newoptionsextra: extraoption };
      });
      if (cleareactSelect.current) {
        cleareactSelect.current.select?.clearValue();
      }
      let newvals = {
        attribute_key: rename.field,
        options: [newValue.value],
      };

      props.createNewOptions(newvals);
    }
  };
  const createOption = (value) => {
    return {
      value,
      option_name: value,
      attribute_key: value,
    };
  };
  const cancelRename = () => {
    const cancerename = { ...rename };
    cancerename.rename = !rename.rename;
    props.rename.cancelRename(cancerename);
  };
  const { Option } = components;

  const IconOption = (props) => {
    if (props.data.__isNew__) {
      return <Option {...props}>{props.data.label}</Option>;
    } else {
      return (
        <Option {...props}>
          <span className="float-end" onClick={() => remove(props)}>
            <i className="fa fa-trash"></i>
          </span>
          {props.data.label}
        </Option>
      );
    }
  };

  // remove attribute options
  const remove = (data) => {
    const { key, id } = data.data;
    const optionsrmove = [...rename.options];
    rename.removeSelection(id);
    const index = optionsrmove.findIndex((item) => item.key === key);
    optionsrmove.splice(index, 1);
    setRename((state) => {
      return { ...state, options: optionsrmove };
    });
  };

  const renameSubmit = (ev) => {
    ev.preventDefault();
    if (rename.headerName.trim() === "") {
      setError("Attribute name can not be blanked");
      return false;
    } else {
      setError("");

      rename.renameSubmit(rename);
    }
  };
  let attrnewopt = [];
  if (rename.options?.length > 0) {
    rename.options.forEach((item) => {
      attrnewopt.push({
        value: item.option_name,
        label: item.option_name,
        key: item.attribute_key,
        id: item["id"] || item["_id"],
      });
    });
  }
  const showFormCanvas = () => {
    props.showCanvas();
  };
  const closeoverlay = () => {
    const cancerename = { ...rename };
    cancerename.rename = !rename.rename;
    props.rename.cancelRename(cancerename);
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    const valuehandler = { ...rename };
    valuehandler[name] = value;
    setRename(valuehandler);
  };

  return (
    <>
      {ReactDOM.createPortal(
        <Overlay closeoverlay={closeoverlay} />,
        document.getElementById("over-lay")
      )}
      {ReactDOM.createPortal(
        <OverlayModal
          rename={rename}
          attrRenaming={attrRenaming}
          renameSubmit={renameSubmit}
          error={error}
          showFormCanvas={showFormCanvas}
          cancelRename={cancelRename}
          cleareactSelect={cleareactSelect}
          attrnewopt={attrnewopt}
          colourStyles={colourStyles}
          IconOption={IconOption}
          createCustomOptionHandler={createCustomOptionHandler}
          onChange={onChangeHandler}
          createNewOption={props.createNewOptions}
        />,
        document.getElementById("over-modal")
      )}
    </>
  );
};

export default RenameAttrModal;
